import { useState } from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { Button, Col, Container, Form, Row } from 'react-bootstrap'
import schema from './signup.schema'
import { FormInput, FormPassword } from '../../formControl'
import { useApi, useYupForm, useLoading } from '../../../hooks'
import { useMutation } from 'react-query'
import toast from '../../toast'
import LayoutAuth from '../../LayoutAuth'
import routes from '../../../core/constants/routes'
import ConfirmEmailModal from './ConfirmEmailModal'
import { getSignupDefaults } from './signupDefaults'

const SignUp = () => {
	const { mainService } = useApi()
	const history = useHistory()
	const location = useLocation()
	const [showConfirmEmail, setShowConfirmEmail] = useState(false)

	const { isLoading, mutate, isSuccess, variables } = useMutation(mainService.signup, {
		onSuccess: () => {
			setShowConfirmEmail(true)
		},
		onError: error => {
			toast.error({ title: 'Signup', body: error.message })
		},
	})

	useLoading(isLoading)

	// The "client portal access enabled" welcome email links here as /signup?email=...
	const useForm = useYupForm(schema, getSignupDefaults(location.search))

	const signedUpEmail = variables?.email || ''

	const goToLogin = () => {
		setShowConfirmEmail(false)
		const search = signedUpEmail ? `?email=${encodeURIComponent(signedUpEmail)}` : ''
		history.push(`${routes.LOGIN}${search}`)
	}

	const handleRegister = data => {
		const payload = {
			...data,
			email: data.email?.toLowerCase() || '',
		}
		mutate(payload);
	}

	const {
		formState: { errors },
		register,
		handleSubmit,
	} = useForm
	return (
		<LayoutAuth>
			<Container style={{ maxWidth: '350px' }} className='flex-grow-1'>
				<Row className='py-5 text-center login h-100 align-items-center'>
					<Col sm={12} className='my-0 mx-auto'>
						<strong>Sign up</strong>
						{isSuccess && (
							<div>
								<p className='fs-sub mt-4 pt-3'>
									Success! Your account has been created. Check your email
									address to confirm your account setup.
								</p>

								<p className='mt-4'>
									Then,{' '}
									<Link to='/login' className='fw-bold text-uppercase fs-small'>
										Log In
									</Link>{' '}
									with your new account details.
								</p>
							</div>
						)}

						{!isSuccess && (
							<Form
								className='form form-default py-4'
								onSubmit={handleSubmit(handleRegister)}
							>
								<FormInput
									basic
									label='First Name'
									placeholder='Enter first Name'
									error={!!errors.firstName}
									errorMessage={errors.firstName?.message}
									wrapperClass='mb-3'
									{...register('firstName')}
								/>
								<FormInput
									basic
									label='Last Name'
									placeholder='Enter last Name'
									error={!!errors.lastName}
									errorMessage={errors.lastName?.message}
									wrapperClass='mb-3'
									{...register('lastName')}
								/>

								<FormInput
									basic
									label='Email'
									placeholder='example@gmail.com'
									error={!!errors.email}
									errorMessage={errors.email?.message}
									wrapperClass='mb-3'
									{...register('email')}
								/>

								<FormPassword
									basic
									type='password'
									label='Password'
									placeholder='Enter password'
									error={!!errors.password}
									errorMessage={errors.password?.message}
									togglePassword
									{...register('password')}
								/>

								<Button className='w-100 mt-5 text-uppercase' type='submit'>
									Create Account
								</Button>
								<p className='mt-4'>
									Already have an account yet?
									<Link to='/login' className='ms-2 fw-bold text-uppercase fs-small'>
										Log In
									</Link>{' '}
								</p>
							</Form>
						)}
					</Col>
				</Row>
			</Container>
			<ConfirmEmailModal
				show={showConfirmEmail}
				email={signedUpEmail}
				onConfirm={goToLogin}
				onHide={goToLogin}
			/>
		</LayoutAuth>
	)
}

export default SignUp
